export default "__VITE_ASSET__2bCxJbqv__"